export default {
    CONDICIONALIDADES_DO_BOLSA_FAMILIA: 6,
    GESTANTE: 7,
    PUERPERA: 8,
    RECEM_NASCIDO: 9,
    CRIANCA: 10,
    PESSOA_COM_DESNUTRICAO: 11,
    PESSOA_EM_REABILITACAO_OU_COM_DEFICIENCIA: 12,
    PESSOA_COM_HIPERTENSAO: 13,
    PESSOA_COM_DIABETES: 14,
    PESSOA_COM_ASMA: 15,
    PESSOA_COM_DPOC_ENFISEMA: 16,
    PESSOA_COM_CANCER: 17,
    PESSOA_COM_OUTRAS_DOENCAS_CRONICAS: 18,
    PESSOA_COM_HANSENIASE: 19,
    PESSOA_COM_TUBERCULOSE: 20,
    SINTOMATICOS_RESPIRATORIOS: 21,
    TABAGISTA: 22,
    DOMICILIADOS_ACAMADOS: 23,
    CONDICOES_DE_VULNERABILIDADE_SOCIAL: 24,
    SAUDE_MENTAL: 26,
    USUARIO_DE_ALCOOL: 27,
    USUARIO_DE_OUTRAS_DROGAS: 28,
}